const FIELD_LABELS: Record<string, string> = {
  billing_frequency: 'Billing Frequency',
  status: 'Status',
  inactive_reason: 'Inactive Reason',
  detail_for_cancellation: 'Detail for Cancellation',
  most_recent_cancellation_date: 'Most Recent Cancellation Date',
  most_recent_rejoin_date: 'Most Recent Rejoin Date',
  notes: 'Notes',
};

export function humanizeField(field: string): string {
  return FIELD_LABELS[field] ?? field.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

// Imported rows carry no history_user; the person's name is embedded in the change reason marker.
export function parseImportedName(changeReason: string | null): string | null {
  if (!changeReason) return null;
  const match = changeReason.match(/^Imported from Monday\s+.*?\s+-\s+(.+)$/);
  return match ? match[1].trim() : null;
}

// Snake_case/lowercase enum tokens render as sentence case; identifiers and dates pass through unchanged.
export function humanizeValue(value: string | null): string {
  if (value === null || value === '') return '—';
  if (/^[a-z][a-z0-9]*(_[a-z0-9]+)*$/.test(value)) {
    const spaced = value.replace(/_/g, ' ');
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
  }
  return value;
}
